export default __webpack_public_path__ + "static/media/jef-logo.636e89f3.svg";